import { createSelector } from "reselect"
import { getSelectedBase } from "modules/portfolio-root/selectors/base"
import { getFullPortfolioBenchmark } from "modules/portfolio-root/selectors/portfolios"
import { getSegment as getAnalyzeTrendsSegment } from "modules/analyze-header/selectors/segment"
import { getEffectiveFilterScope } from "modules/analyze-header/selectors/filter-scope"
import { computeScopedBaseSegment } from "helpers/filter-scope"

export const getBasePositionSet = createSelector(
  [getFullPortfolioBenchmark, getSelectedBase],
  (benchmark, selectedBase) => {
    if (selectedBase) {
      return {
        type: selectedBase.type,
        id: selectedBase.resourceId || selectedBase.id,
        weight: selectedBase.weight,
        ...(selectedBase.experimentId && { experimentId: selectedBase.experimentId }),
      }
    }

    return {
      type: "BENCHMARK",
      id: benchmark.id,
      weight: benchmark.weight,
    }
  },
)

export const getBasePositionSetWithSegment = createSelector(
  [getBasePositionSet, getAnalyzeTrendsSegment, getEffectiveFilterScope],
  (basePositionSet, segment, effectiveFilterScope) => ({
    ...basePositionSet,
    segment: computeScopedBaseSegment(segment, effectiveFilterScope),
  }),
)

export const getBaseSignature = createSelector(
  [getBasePositionSet],
  (base) => base.id,
)

export const getBaseSegmentSignature = createSelector(
  [getBasePositionSetWithSegment],
  ({ id, segment }) => `${id}${JSON.stringify(segment)}`,
)
